import { create } from "zustand";

export const useSchedulerStore = create((set) => ({
  providers: [],
  setProviders: (providers) => set({ providers }),
  fileName: null,
  setFileName: (fileName) => set({ fileName }),
}));
